module.exports = __webpack_public_path__ + "static/img/wsbx1.6dd51e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wsbx1.png
// module id = fgYW
// module chunks = 1